import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Updater } from "use-immer";

import { IgListItemButton, IgTypography } from "@intelligems/ig-theme";
import { GenericExperienceFe } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { CustomExpression } from "@src/components/targeting/components/audienceTargeting/CustomExpression";
import { RolloutAudienceIndicator } from "@src/features/sharedExperience/components/rollouts/components/RolloutAudienceIndicator";
import { getHideSummary } from "@src/features/sharedExperience/components/rollouts/utils";
import {
  resetCustomAudienceState,
  selectedAudienceRolloutInfo,
  selectedAudienceState,
  setSourcesToBeUsed,
} from "@src/store/slices/audiences";

interface RolloutsAudienceWrapperProps {
  isAllVisitors: string;
  setIsAllVisitors: Updater<string>;
  experience: GenericExperienceFe;
}
export const RolloutsAudienceWrapper = ({
  isAllVisitors,
  setIsAllVisitors,
  experience,
}: RolloutsAudienceWrapperProps) => {
  const dispatch = useDispatch();
  const audienceState = useSelector(selectedAudienceState);
  const rolloutsInfo = useSelector(selectedAudienceRolloutInfo);

  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography>Who would you like to roll this out to?</IgTypography>
      </Grid>
      <Grid item container direction={"row"}>
        <IgListItemButton
          onClick={() => {
            setIsAllVisitors("all");
            dispatch(resetCustomAudienceState());
            setSourcesToBeUsed({
              testTargeting: false,
              dashboardTargeting: false,
              analyticTableTargeting: false,
            });
          }}
          selected={isAllVisitors === "all"}
          label={"All Visitors"}
        />
        <IgListItemButton
          onClick={() => {
            setIsAllVisitors("limited");
          }}
          selected={isAllVisitors === "limited"}
          label={"A Limited Audience"}
        />
        <IgListItemButton
          onClick={() => {
            setIsAllVisitors("link");
          }}
          selected={isAllVisitors === "link"}
          label={"Visitors With Link"}
        />
      </Grid>
      {!getHideSummary(
        isAllVisitors,
        audienceState?.storedAudience,
        rolloutsInfo
      ) && (
        <Grid item>
          <RolloutAudienceIndicator />
        </Grid>
      )}
      <Grid item>
        {isAllVisitors === "all" ? (
          <IgTypography>
            This test group will be rolled out to all visitors viewing your
            site.
          </IgTypography>
        ) : audienceState.audience && isAllVisitors === "limited" ? (
          <CustomExpression
            audienceState={audienceState.audience}
            queryParamIndex={0}
            isRolloutRender={true}
            experienceCategory={experience.category}
          />
        ) : isAllVisitors === "link" ? (
          <Grid item>
            <IgTypography>
              Use Link Targeting if you would prefer to show this Experience
              only to users holding a special link.
            </IgTypography>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
